        <!-- PwdReset 密码重置 -->
<template>
  <div>
    <!-- 表头 -->
    <div class="pwdReset">
      <div class="pwdReset_return" @click="returnClick()">
        <i class="el-icon-arrow-left fl"></i>
        <span class="fl">返回</span>
      </div>
      <h1>密码重置</h1>
      <div class="pwdReset_time clearfix">
        <i class="el-icon-date fl"></i>
        <span class="fl">{{ dataTime }}</span>
        <span class="fl">{{ textTime }}</span>
      </div>
    </div>

    
    <!-- 内容 -->
    <iframe
      class="pwdReset_content"
      :src="apiUrls + '?txcode=PwdReset'"
      frameborder="0"
    >
    </iframe>
  </div>
</template>

<script>
// 引入日期时间
import { dateTime } from "../../assets/js/data";
export default {
  data() {
    return {
      // 定时器
      timer: "",
      // 日期时间
      dataTime: "",
      // 星期
      textTime: "",
      apiUrls:''
    };
  },
  created() {
    this.apiUrls = this.apiUrl;
    //   日期时间赋值
    this.dataTime = dateTime();
    //   清除定时器
    window.clearInterval(this.timer);
    let _this = this;
    // 定时更新时间
    this.timer = setInterval(() => {
      _this.dataTime = dateTime();
    }, 1000);
    
    let date = new Date();
    let num = date.getDay();
    if (num == 0) {
      this.textTime = "星期天";
    }
    if (num == 1) {
      this.textTime = "星期一";
    }
    if (num == 2) {
      this.textTime = "星期二";
    }
    if (num == 3) {
      this.textTime = "星期三";
    }
    if (num == 4) {
      this.textTime = "星期四";
    }
    if (num == 5) {
      this.textTime = "星期五";
    }
    if (num == 6) {
      this.textTime = "星期六";
    }
  },
  methods: {
    // 返回上一级
    returnClick() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="less" scoped>
// 表头
.pwdReset {
  width: 100%;
  height: 50px;
  background-color: #304156;
  position: relative;
  h1 {
    min-width: 300px;
    margin: 0 auto;
    height: 50px;
    line-height: 50px;
    font-size: 26px;
    letter-spacing: 6px;
    font-weight: bold;
    text-align: center;
    color: #fff;
  }
  .pwdReset_return {
    position: absolute;
    top: 0;
    left: 0;
    height: 50px;
    overflow: hidden;
    line-height: 50px;
    color: #fff;
    &:hover {
      cursor: pointer;
      text-shadow: #000 0 0 2px;
    }
    i {
      font-weight: bold;
      margin-left: 20px;
      font-size: 20px;
      line-height: 52px;
    }
    span {
      line-height: 50px;
      font-size: 20px;
    }
  }
  .pwdReset_time {
    position: absolute;
    top: 0;
    right: 0;
    height: 50px;
    padding: 0 20px;
    color: #fff;
    i {
      font-size: 32px;
      line-height: 50px;
    }
    span {
      margin: 0 20px;
      font-size: 28px;
      line-height: 50px;
    }
  }
}

// 内容
.pwdReset_content {
  width: calc(100% - 40px);
  height: calc(100% - 80px);
  position: fixed;
  top: 65px;
  left: 20px;
}
</style>